module.exports = (__webpack_require__("U2o4"))("TAxY");